import { useState } from 'react';
import SessionCRUDActions, {
  useSessionCRUDActions,
} from '@mm/state/actions/SessionCRUDActions';
import AuthenticatedController from '@mm/state/controllers/AuthenticatedController';
import { SessionObject } from '@mm/state/interfaces/session';
import CompanyUsersModel from '@mm/state/model/CompanyUsersModel';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { getErrorJson } from '@mm/utils';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

export const useTokenLogin = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const sessionCRUDActions = useSessionCRUDActions();

  const [isLoginInProgress, setIsLoginInProgress] = useState(false);
  const [user, setUser] = useState<CompanyUsersModel | undefined>();
  const [err, setErr] = useState<any>();

  const history = useHistory();

  const login = async (accessToken?: string) => {
    setIsLoginInProgress(true);
    try {
      if (accessToken) {
        AuthenticatedController.storeSession({
          authToken: accessToken,
        } as SessionObject);
      }

      const user = await sessionCRUDActions.retrieveMyUser();

      if (user.id && accessToken) {
        const session = {
          ...user,
          authToken: accessToken,
        } as any as SessionObject;

        dispatch(SessionCRUDActions.retrieved(session));
        AuthenticatedController.storeSession(session);
        history.push('/');
      }

      setUser(user);
    } catch (err) {
      if (err instanceof Response) {
        const responseErrorBody = await getErrorJson(err);

        if (responseErrorBody.errors) {
          return setErr(responseErrorBody.errors[0]);
        }

        setErr('Something went wrong');
      }
    } finally {
      setIsLoginInProgress(false);
    }
  };

  const logout = async () => {
    setErr(undefined);
    setUser(undefined);
    await sessionCRUDActions.clear();

    if (window.MMApp?.loginUrl) {
      window.location.href = window.MMApp.loginUrl || '/';
    }
  };

  return {
    login,
    logout,
    isLoginInProgress,
    user,
    err,
  };
};
